import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(5, 0, 6),
    width: `calc(100% + ${theme.spacing(6)}px)`,
    marginLeft: -theme.spacing(3),
    marginRight: -theme.spacing(3),
    marginTop: -theme.spacing(4),
    display: 'flex',
    alignItems: 'stretch',
    [theme.breakpoints.down('xs')]: {
      width: `calc(100% + ${theme.spacing(4)}px)`,
      marginLeft: -theme.spacing(2),
      marginRight: -theme.spacing(2),
      marginTop: -theme.spacing(3),
    },
  },
  backRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(3.5),
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover $backLabel': {
      textDecoration: 'underline',
    },
  },
  backButton: {
    color: theme.palette.secondary.dark,
    padding: theme.spacing(0.5),
  },
  backLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.contrastText,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  content: {
    flex: 1,
    minWidth: 0,
    paddingTop: theme.spacing(1),
  },
  title: {
    fontSize: 36,
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(2.5),
    lineHeight: 1.2,
  },
  description: {
    fontSize: 14,
    color: theme.palette.primary.contrastText,
    opacity: 0.78,
    lineHeight: 1.8,
    textAlign: 'justify',
  },
  descriptionClamped: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 4,
      WebkitBoxOrient: 'vertical',
    },
  },
  descriptionToggle: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
    },
    background: 'none',
    border: 'none',
    padding: 0,
    marginTop: theme.spacing(0.5),
    cursor: 'pointer',
    color: theme.palette.secondary.main,
    opacity: 0.78,
    fontSize: 13,
    fontWeight: 600,
    textDecoration: 'underline',
    '&:hover': {
      opacity: 1,
    },
  },
  infoCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    padding: theme.spacing(4),
    minWidth: 340,
    maxWidth: 400,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    boxShadow: theme.shadows[8],
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
    },
    '@media (max-width: 364px)': {
      padding: theme.spacing(2.5),
    },
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  infoIconWrapper: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  infoIcon: {
    color: theme.palette.common.white,
  },
  infoTextBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  infoLabel: {
    fontSize: 11,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  infoValue: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  divider: {
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(0.5, 0),
  },
  startButton: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.white,
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 2,
    borderRadius: 10,
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
  },
  certificateButton: {
    backgroundColor: '#2e7d32',
    color: theme.palette.white,
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 2,
    borderRadius: 10,
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#1b5e20',
    },
  },
}))

export default useStyles
